/* eslint-disable jira/filename-case */
import { token } from '@atlaskit/tokens';

export const TEMPLATE_TILE_WIDTH_IN_PX = 300;
export const TEMPLATE_TILE_HEIGHT_IN_PX = 252;
const NUMBER_OF_VISIBLE_TILES_VERTICALLY = 3;

// Two lines of comment-appearance body text (~24px per line; see RenderedDescription compact).
export const TEMPLATE_TILE_SHORT_DESCRIPTION_MAX_HEIGHT_PX = 48;
/**
 * to show max 3 tiles in a row:
 * 3 * ${TEMPLATE_TILE_WIDTH_IN_PX}px - tiles width
 * 2 * ${token('space.200')} - gap between tiles
 * 2 * ${token('space.300')} - modal padding on both sides
 * ${token('space.250')} - scrollbar width
 */
export const MODAL_WIDTH: string = `calc(3 * ${TEMPLATE_TILE_WIDTH_IN_PX}px + 2 * ${token('space.200')} + 2 * ${token('space.300')} + ${token('space.250')})`;

// Line height of a single line of the modal title. `ModalTitle` in
// `@atlaskit/modal-dialog/modal-title` renders with `font.heading.medium`,
// whose line height is 24px.
const MODAL_TITLE_LINE_HEIGHT_IN_PX = 24;

// Height of the modal header (title row). Mirrors `ModalHeader` styles in
// `@atlaskit/modal-dialog/modal-header`:
//   paddingBlockStart: space.300, paddingBlockEnd: space.200, marginBlockEnd: -space.025
// plus one line of the modal title (`font.heading.medium`).
const MODAL_HEADER_HEIGHT = `calc(${token('space.300')} + ${token('space.200')} - ${token('space.025')} + ${MODAL_TITLE_LINE_HEIGHT_IN_PX}px)`;

/**
 * Height sized to show exactly ${NUMBER_OF_VISIBLE_TILES_VERTICALLY} tile rows.
 *
 * Vertical breakdown (top → bottom of the dialog):
 * - ${MODAL_HEADER_HEIGHT} - modal header (title + its block padding)
 * - 2 * ${token('space.025')} - `ModalBody` block padding (scroll keyline)
 * - ${NUMBER_OF_VISIBLE_TILES_VERTICALLY} * ${TEMPLATE_TILE_HEIGHT_IN_PX}px - tile rows
 * - ${NUMBER_OF_VISIBLE_TILES_VERTICALLY - 1} * ${token('space.200')} - grid gaps between rows
 * - ${token('space.300')} - tiles grid `paddingBlockEnd`
 *
 * Note: unlike `MODAL_WIDTH`, no scrollbar allowance is added here - a vertical
 * scrollbar only affects width, not height.
 */
export const MODAL_HEIGHT: string = `calc(
	${MODAL_HEADER_HEIGHT} + 2 * ${token('space.025')} + ${NUMBER_OF_VISIBLE_TILES_VERTICALLY} * ${TEMPLATE_TILE_HEIGHT_IN_PX}px + ${NUMBER_OF_VISIBLE_TILES_VERTICALLY - 1} * ${token('space.200')} + ${token('space.300')})`;
